import { render, staticRenderFns } from "./PaxelSkeletonLoader.vue?vue&type=template&id=21dc1ae6&"
import script from "./PaxelSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./PaxelSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./PaxelSkeletonLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports